export default "__VITE_ASSET__B7RYSkN6__"